import Swiper from 'swiper/swiper-bundle';

export function ticker() {
  const swiper = new Swiper('.swiper-container', {
    slidesPerView: 'auto',
    loop: true,
    autoplay: {
      delay: 0,
      disableOnInteraction: false
    },
    speed: 2000,
    effect: 'slide',
    breakpoints: {
      0: {
        spaceBetween: 30,
      },
      1024: {
        spaceBetween: 60,
      },
    },
  });
}


// WEBPACK FOOTER //
// app/scripts/components/ticker.js